import { useContext } from 'react';

import { StateContext } from 'state/state-context';
import { footer, roundedLink } from './styles.module.scss';

export const Footer = () => {
  const { content, brand } = useContext(StateContext);
  const { moneyAdvice = {}, FSCS = {} } = content('footer');
  return (
    <footer className={footer} role="contentinfo">
      <p>
        {moneyAdvice.copy}{' '}
        <a className={`${roundedLink}`} href={moneyAdvice.link}>
          {moneyAdvice.linkText}
        </a>
      </p>
      <p>
        {FSCS.copy}{' '}
        <a className={`${roundedLink}`} href={FSCS[`link${brand.toLowerCase()}`]}>
          {FSCS.linkText}
        </a>
      </p>
    </footer>
  );
};
